import React from 'react';
import { TiltingCard } from './components/TiltingCard';
export function App() {
  return <main className="min-h-screen w-full bg-gradient-to-br from-gray-900 via-gray-800 to-black flex flex-col items-center justify-center p-6 overflow-hidden" data-id="element-0">
      {/* Background decorative elements */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-1" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-2" />

      <div className="text-center mb-12 z-10" data-id="element-3">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3 tracking-tight" data-id="element-4">
          Interactive Profile Card
        </h1>
        <p className="text-gray-400 max-w-md mx-auto text-[14px]" data-id="element-5">
          Hover over the card to see the 3D tilting effect and dynamic glare.
        </p>
      </div>

      <div className="z-10" data-id="element-6">
        <TiltingCard data-id="element-7" />
      </div>
    </main>;
}